"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// office-ui-fabric-react@6.214.0
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
var set_version_1 = require("@uifabric/set-version");
set_version_1.setVersion('office-ui-fabric-react', '6.214.0');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/version.js
// module id = 464
// module chunks = 0